<template>
  <div class="notification-btn-con"
       @mouseenter="handleMouseenter"
       @mouseleave="handleMouseleave">
    <Badge :dot="!!count">
      <Icon type="md-notifications-outline"
            size="23" />
    </Badge>
    <div class="dropdown"
         v-show="currentVisible">
      <div class="dropdown-header">
        <h4>
          站内消息通知
          <small class="mb-0 opacity-80">您有{{count}}条未读信息</small>
        </h4>
      </div>
      <div>
        <ul class="dropdown-item">
          <li v-for="(item, index) in data" :key="index" @click="goMessage(item)">
            <h3>{{item.title}}</h3>
            <p>{{item.create_time}}</p>
          </li>
        </ul>
        <div class="dropdown-more"  @click="goNotification"><span>查看所有信息</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: "notifications",
  data () {
    return {
      currentVisible: false
    };
  },
  props: {
    count: {
      type: Number,
      default: 0
    },
    data: {
      type: Array,
      default: []
    },
  },
  methods: {
    ...mapActions([
      'getContentByMsgId',
    ]),
    //数据源
    handleMouseenter () {
      this.currentVisible = true;
      if(this.count <= 0){
        this.currentVisible = false
        return
      }
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.currentVisible = true;
      }, 250);
    },
    handleMouseleave () {
      this.currentVisible = false;
      if(this.count <= 0){
        this.currentVisible = false
        return
      }
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.currentVisible = false;
        }, 150);
      }
    },
    goMessage(row){
      let data =this.getContentByMsgId({ row })
      this.$router.push({
        name: 'message'
      })
    },
    goNotification () {
      this.$router.push({
        name: 'message'
      })
    }
  },
  watch:{
    count: function (val, oldVal) {
      if(val <= 0){
        this.currentVisible = false
      }
    },
  }
}
</script>

<style lang="less" scoped>
.notification-btn-con {
  width: 54px;
  text-align: center;
  line-height: 54px;
  height: 54px;
  position: relative;
  z-index: 100;

  .dropdown {
    width: 21.875rem;
    height: auto;
    display: block;
    -webkit-transform: scale(1) !important;
    transform: scale(1) !important;
    -webkit-transform-origin: 29px -50px;
    transform-origin: 29px -50px;
    opacity: 1;
    visibility: visible;
    position: absolute;
    will-change: top, left;
    border: 0 solid #ccc;
    right: -107px;
    top: 3.3rem !important;
    left: auto !important;
    padding: 0;
    margin: 0;
    -webkit-box-shadow: 4px 10px 15px 1px rgba(90, 80, 105, 0.2);
    box-shadow: 4px 10px 15px 0px rgba(90, 80, 105, 0.2);
    -webkit-user-select: text;
    transform: perspective(500px) rotateX(60deg);
    &-header {
      background: linear-gradient(250deg, #3a455b, #3f4d67);
      h4 {
        font-weight: normal;
        line-height: 26px;
        font-size: 14px;
        color: #ffffffd1;
        padding: 10px;
        text-align: left;
        small {
          float: right;
          font-weight: 300;
          color: #ffffff99;
          font-size: 12px;
        }
      }
    }
    &-item {
      background: #fff;
      list-style: none;
      line-height: 23px;
      text-align: left;
      li {
        padding: 3px 12px;
        border-bottom: 1px solid #f1f1f1;
        cursor: pointer;
        h3 {
          color: #666;
          font-weight: 500;
          font-size: 14px;
        }
        p {
          color: #888;
          font-size: 12px;
        }
        &:hover {
          cursor: pointer;
          background: #ececec;
          h3 {
            color: #333;
            font-weight: 600;
          }
        }
      }
    }
    &-more {
      line-height: 32px;
      background: #f7f9fa;
      color: #666;
      text-align: right;
      cursor: pointer;
      span {
        color: #999;
        padding: 0px 15px;
        &:hover {
            color: #58b1eb;
        }
      }
    }
  }
}
</style>
